// @ vendors
const { Promise } = require('es6-promise');

// @ helpers
const { APIGet, APIPost, base64ToBlob } = require('utilities/APIRequestHelper');
const { download } = require('utilities/fileDownloadHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { getLanguage } = require('core/i18n').i18n;
const getExtension = require('utilities/mimeTypeToExt');

// @ constants
const {
    INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_SEND_BUDGET_EMAIL_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_SEND_BUDGET_EMAIL_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_SEND_BUDGET_EMAIL_FAILURE
} = require('../../insuranceConstants/actionTypes');

const getDocumentRequest = docType => ({
    type: INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_REQUEST,
    data: { docType }
});

const getDocumentSuccess = docType => ({
    type: INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_SUCCESS,
    data: { docType }
});

const getDocumentFailure = (docType, error) => ({
    type: INSURANCE_REQUEST_RELATED_RNC_GET_DOCUMENT_FAILURE,
    data: {
        docType,
        error
    }
});

const sendBudgetEmailRequest = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SEND_BUDGET_EMAIL_REQUEST
});

const sendBudgetEmailSuccess = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SEND_BUDGET_EMAIL_SUCCESS
});

const sendBudgetEmailFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_SEND_BUDGET_EMAIL_FAILURE,
    data: { error }
});

const getDocument = (docType, docName) => (dispatch, getState) => {
    const currentState = getState().insuranceRequestRelatedRNCState.get('data');
    if (currentState.get('id')) {
        dispatch(getDocumentRequest(docType));
        const requestData = {
            query: {
                documentType: docType,
                language: getLanguage().toUpperCase(),
                isClientWithoutAccounts: true
            }
        };
        return APIGet(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestDocument', { id: currentState.get('id') }),
            requestData
        )
            .then(response => {
                const { documentFile } = response.data;
                const { base64, contentType } = documentFile;
                const fileExtension = getExtension(contentType);
                const docNamePdf = `${docName}.${fileExtension}`;
                const base64string = `data:${contentType};base64,${base64}`;
                const b64toBlobResponse = base64ToBlob(base64string)

                download(b64toBlobResponse, docNamePdf, contentType);
                dispatch(getDocumentSuccess(docType, response.data));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(getDocumentFailure(docType));
                } else {
                    throw response;
                }
            });
    }
};

const sendBudgetEmail = () => (dispatch, getState) => {
    const currentState = getState().insuranceRequestRelatedRNCState.get('data');
    if (currentState.get('id')) {
        dispatch(sendBudgetEmailRequest());

        return APIPost(
            dispatch,
            apiURLBuilder.getURL('insuranceSendBudgetEmail', {
                id: currentState.get('id'),
                lang: getLanguage().toUpperCase()
            })
        )
            .then(response => dispatch(sendBudgetEmailSuccess(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(sendBudgetEmailFailure(response.error));
                } else {
                    throw response;
                }
            });

    } else {
        return Promise.resolve();
    }
};

module.exports = {
    getDocument,
    sendBudgetEmail
};